export default __webpack_public_path__ + "static/media/rika_l.bd2695ee.jpg";